module.exports = __webpack_public_path__ + "static/media/home-decor-2.249f600c.jpeg";